import React from 'react';
import { BODY, MONO } from '../../primitives.js';

const h = React.createElement;

/**
 * Auto-growing multi-line text.
 *
 * @param {object} p
 * @param {string} [p.value]
 * @param {string} [p.defaultValue]
 * @param {(e: any) => void} [p.onChange]
 * @param {number} [p.rows]
 * @param {number} [p.maxRows]
 * @param {boolean} [p.mono]
 * @param {boolean} [p.count]
 * @param {number} [p.maxLength]
 * @param {boolean} [p.invalid]
 * @param {boolean} [p.readOnly]
 * @param {boolean} [p.disabled]
 * @param {string} [p.placeholder]
 * @param {React.CSSProperties} [p.style]
 * @param {any} [p.attr] - plus any native attribute
 */
export function Textarea({ value, defaultValue, onChange, rows = 3, maxRows = 12, mono, invalid, readOnly, disabled, count, maxLength, placeholder, style, ...rest }) {
  const ref = React.useRef(null);
  const [len, setLen] = React.useState(String(value != null ? value : defaultValue || '').length);
  const fit = () => { const el = ref.current; if (!el) return; el.style.height = 'auto'; const lh = parseFloat(getComputedStyle(el).lineHeight) || 20; el.style.height = Math.min(el.scrollHeight + 4, lh * maxRows + 22) + 'px'; };
  React.useLayoutEffect(fit, [value]);
  return h('span', { style: { position: 'relative', display: 'block' } },
    h('textarea', { ref, value, defaultValue, rows, readOnly, disabled, maxLength, placeholder, 'aria-invalid': invalid || undefined, ...rest, className: 'gx-input',
      onChange: (e) => { setLen(e.target.value.length); fit(); onChange && onChange(e); },
      style: { display: 'block', width: '100%', boxSizing: 'border-box', resize: 'none', padding: count ? '10px 12px 24px' : '10px 12px', fontFamily: mono ? MONO : BODY, fontSize: mono ? 12.5 : 13.5, fontWeight: mono ? 400 : 500, lineHeight: 1.55, color: readOnly ? 'var(--tx2)' : 'var(--tx)', background: readOnly ? 'var(--inset)' : 'var(--input)', border: readOnly ? '2px dashed var(--line2)' : `2px solid ${invalid ? 'var(--coral)' : 'var(--ink)'}`, borderRadius: 10, outline: 'none', opacity: disabled ? .55 : 1, ...style } }),
    count ? h('span', { 'aria-live': 'polite', style: { position: 'absolute', right: 10, bottom: 6, fontFamily: MONO, fontSize: 10, color: maxLength && len > maxLength * .9 ? 'var(--gold-tx)' : 'var(--mut2)', pointerEvents: 'none' } }, maxLength ? `${len} / ${maxLength}` : len) : null);
}
